export enum JOB_STATUS {
	OPEN = "OPEN",
	BOOKED = "BOOKED",
	BOOKED_WITH_UNMANNED_SHIFTS = "BOOKED_WITH_UNMANNED_SHIFTS",
	DECLINED = "DECLINED",
	DELETED = "DELETED",
	CANCELLED = "CANCELLED",
}

// TODO: Translate order statuses
